import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'coin-chat-dialog-content',
  templateUrl: './chat-dialog-content.component.html',
  styleUrl: './chat-dialog-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatDialogContentComponent {}
